<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="externalRequestsHeaders"
                    :items="request.external_request"
                    :mobile-breakpoint="0"
                    name="usersData"
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                {{ item.title }}
                            </td>
                            <td>
                                {{ item.receiverEmail }}
                            </td>
                            <td>
                                <template v-if="item.createdBy.firstName && item.createdBy.lastName">
                                    {{ item.createdBy.firstName }} {{ item.createdBy.lastName }}
                                </template>
                                <template v-else>
                                    {{ item.createdBy.username }}
                                </template>
                            </td>
                            <td>
                                {{ formatDate(item.createdAt) }}
                            </td>
                            <td>
                                <div class="d-inline-flex">
                                    <v-tooltip :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn
                                                icon
                                                data-sentry-label="Szczegóły zapytania"
                                                v-on="on"
                                                @click="openExternalRequest(item.id)"
                                            >
                                                <v-icon color="blue">
                                                    mdi-ballot
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Szczegóły zapytania</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import router from '@/router'
import tooltipDelay from '@/mixins/tooltip'
import dateFormatter from '@/mixins/dateFormatter'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'Enquiries',
    mixins: [ tooltipDelay, dateFormatter ],
    props: {
        request: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            externalRequestsHeaders: [
                {
                    text: 'Tytuł',
                    value: 'title',
                    sortable: false,

                },
                {
                    text: 'Email dostawcy',
                    value: 'receiverEmail',
                    sortable: false,
                    width: 330
                },
                {
                    text: 'Wysyłający',
                    value: 'createdBy',
                    sortable: false,
                    width: 330
                },
                {
                    text: 'Data złożenia',
                    value: 'createdAt',
                    sortable: false,
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 70
                }
            ],
        }
    },
    methods: {
        openExternalRequest(externalRequestId) {
            router.push({
                name:  'purchasesRequestsExternalRequestRead',
                params: {
                    externalRequestId: externalRequestId,
                }
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
    },
}
</script>